<template>
	<div
		:data-chronicle="metadata.i_chronicle_id"
		:class="['webmd-tool-slideshow', 'module-' + moduleTitle, options.mode,
			{'fed-ia-ss' : fedConfig },
			{'vert-ss-dflt':options.mode === 'vertical'},
			{'text-only-ss':textOnlySS}]"
		:data-module-type="moduleType"
		:data-mode="options.mode"
		:data-e2e="moduleTitle"
		:data-artId="metadataModule.i_chronicle_id"
		v-if="options.mode"
		:style="fedStyle"
	>
		<div class="ss-inner-container">
			<header class="page-header">
				<a
					class="fed-tag"
					:data-program-id="fedConfig.programid"
					v-if="fedConfig"
					:href="fedConfig.tocLink"
					v-metric="{module: 'ia-fed',link: 'toc'}"
				>
					{{ fedConfig.title }}
				</a>
				<h1>{{ slideshow.title }}</h1>
			</header>
			<div class="med-text">
				<AssetReview :chronic-id="chronicId" />
			</div>
			<div
				class="text-ss-border"
				v-if="textOnlySS"
			></div>
			<div
				class="slideshow-container"
				:class="{text_slide: slideshowType === 'No Image'}"
			>
				<div
					v-if="options.mode === 'vertical'"
					class="vss-container"
				>
					<div
						class="slide"
						:class="{'disabled': ((index+1) > 1) && options.mode !== 'vertical'}"
						:data-slide="index+1"
						:id="'slide-' + (index + 1)"
						v-for="(slide, index) in slides"
						:key="index"
					>
						<div
							class="slide-image"
							v-if="slide.slide_img && slide.slide_img.path"
						>
							<picture>
								<source
									:srcset="getImagePath(slide, true, index)"
									media="(max-width: 466px)"
								/>
								<img
									:loading="`${index === 0 ? 'auto' : 'lazy'}`"
									:src="getImagePath(slide, false, index)"
									:title="slide.slide_caption_title"
									:alt="slide.slide_caption_title"
									width="375"
									height="auto"
								/>
							</picture>
						</div>
						<div
								v-if="!hideSlideCount"
								class="slide-count-bbl"
							>
								<span>
									<strong>{{ index + 1 }}</strong>
									<span class="seperator">/</span>
									<span class="total-slides">{{ totalSlides }}</span>
								</span>
						</div>						
						<div class="content-section">
							<header
								class="slide-header inf_sliderheader"
							>
								<h2>
									{{ slide.slide_caption_title }}
								</h2>
							</header>
							<div
								class="caption inf_caption"
								v-html="slide.slide_caption_text['#cdata-section']"
							>
							</div>
						</div>
					</div>
			</div>

			<div class="sources-and-share-bar">
				<div class="article__publication-sources">
					<AssetFooter />
				</div>
			</div>

			<div class="ad-container" v-if="hasconmkttjg">
				<!-- Ad slot will be rendered here -->
				<div 
					id="footer-ad-pos-141"
					class="module ad footer-ad-141">
				</div>
			</div>

			<div
				class="next-ss-btm-mod"
				v-if="(!isMobile && !isNewTabSpec && displayNextArtNav) || (isMobile && isFlowingFromNews)"
			>
				<div class="mask">
					<a
						:href="nextSsbtmMod(nextArticle)"
						class="next-title"
						v-metric="{module: 'art-bot-dd'}"
					>
						<span
							class="next-label"
							v-if="nextArticle.contentType"
						>
							NEXT {{ nextArticle.contentType }}
						</span>
						<span class="next-text">
							{{ nextArticle.title ? nextArticle.title : nextAsset.title }}
							<i class="webmd-icon-right-arrow"></i>
						</span>
					</a>
				</div>
			</div>
			<div
				id="rc-tp-module-ss"
				v-if="uaType === 'mobile' && isInfinite && instreamRecModule"
			>
			</div>
			<SetRendered
				:chronic-id="chronicId"
				:data="this.moduleByChronicId"
			/>
		</div>
		</div>
	</div>
</template>

<script>
// eslint-disable-next-line import/extensions,import/no-unresolved,import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';
import axios from 'axios';
import { createApp } from 'vue';
import _has from 'lodash/has';
import { merge } from 'lodash';
import { ua } from 'webmd-useragent';
import AssetReview from 'webmd-asset-medical-review/src/Component.vue';
import iaAd from 'webmd-ia-ad/src/Component.vue';
import AssetFooter from 'webmd-asset-footer/src/Component.vue';
import instreamFeaturedModule from 'instream-featured-module/src/Component.vue';
import MedicalReference from 'webmd-medical-reference/src/Component.vue';
import webmdNewsletter from 'webmd-newsletter/src/Component.vue';
import webmdIAModule from 'webmd-ia-module/src/Component.vue';
import metric from 'webmd-vuejs-metrics';
// eslint-disable-next-line import/no-self-import
import instreamRelatedModule from 'webmd-instream-related-module/src/Component.vue';
import SlideShowReference from './Component.vue';
import SetRendered from './SetRendered.vue';

export default {
	name: 'Slideshow',
	data() {
		return {
			ads: {},
			nextArticle: false,
			moduleType: 'DynamicSlideshow',
			moduleTitle: 'dyn-ss',
			slideshowType: '',
			refreshAds: true,
			slideshow: {},
			moduleByChronicId: {},
			slides: [],
			image_server_url: 'https://img.wbmdstatic.com/vim/live',
			nextAsset: {},
			config: {
				headers: { Accept: 'application/json' },
			},
			lastSlide: false,
			initialized: false,
			stickyAdTimer: null,
			adTimer: null,
			footerItems: ['sources', 'disclaimer'],
			ssend: true,
			pvTimer: {},
			lastSlideReached: false,
			options: {},
			isMobile: false,
			hasconmkttjg: false,
			ecdQuery: '',
			defaults: {
				mode: 'vertical',
				dots: false,
				nav: false,
				autoHeight: true,
				margin: 16,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn',
				mouseDrag: false,
				scrollTo: {
					scrollDesktop: true,
					scrollMobile: true,
					speed: 500,
				},
				vssSettings: {
					pvTimeout: 1000,
					adDelay: 1000,
					lazyLoadAds: false,
					adFrequency: 1,
					refreshBannerAd: true,
					refreshOnScroll: true,
					stickyBanner: true,
					stickyRRad: true,
					instreamAds: {
						desktop: {
							enabled: false,
							pos: '101',
							sizes: [[728, 90], [970, 90], [970, 250]],
							runwayAd: false,
						},
						tablet: {
							enabled: true,
							pos: '101',
							sizes: [[728, 90], [350, 200], [350, 600]],
							runwayAd: false,
						},
						mobile: {
							enabled: true,
							pos: '2026',
							sizes: [[300, 50], [300, 51], [300, 250], [300, 253], [320, 50], [320, 51]],
							runwayAd: false,
						},
					},
					slideHeaderPosition: 'belowImage',
					seamless: true,
				},
			},
			slider: {},
			siteId: 3,
			currentSlide: 1,
			uaType: 'desktop',
			truncated: false,
			stickySlider: '',
			displayNextArtNav: false,
			previousY: 0,
			instreamAds: {
				enabled: false,
				pos: '101',
				sizes: [[728, 90], [970, 90], [970, 250]],
				runwayAd: false,
			},
			artNum: 1,
			adCheckCount: 1,
		};
	},
	components: {
		AssetReview,
		AssetFooter,
		SetRendered,
	},

	props: {
		chronicId: {
			type: String,
			default: '091e9c5e8146bf61',
		},
		fedConfig: {
			required: false,
		},
		infArticleNumber: {
			type: Number,
			default: 1,
		},
		settings: {
			type: Object,
			default() {
				return {};
			},
		},
		isInitialLoad: {
			type: Boolean,
			default: false,
		},
		infinite: {
			type: Boolean,
			default: false,
		},
		nextArticleSource: {
			type: String,
			required: false,
			default: '',
		},
		instreamRecModule: {
			type: Boolean,
			default: true,
		},
		turnOffInfinite: {
			type: Boolean,
			default: false,
		},
		hideSlideCount: {
			type: Boolean,
			default: false,
		},
		medrefToss: {
			type: Boolean,
			default: false,
		},

		iaAds: {
			type: Object,
			default() {
				return {
					desktop: {
						clntWidth: 1121,
						pos: '141',
						sizes: [[728, 90], [728, 92]],
					},
					tablet: {
						clntWidth: 767,
						pos: '923',
						sizes: [1, 9],
					},
					mobile: {
						clntWidth: '',
						pos: '2026',
						sizes: [[300, 50], [300, 51], [300, 250], [300, 253], [320, 50], [320, 51]],
					},
				};
			},

		},

		isFlowingFromNews: {
			type: Boolean,
			default: false
		},

	},

	computed: {
		getSlideshow() {
			const moduleData = this.moduleData || false;
			let slides = [];
			let slideshow = {};

			if (moduleData && moduleData.content_section && moduleData.content_section.cons_slideshow) {
				slideshow = moduleData.content_section.cons_slideshow;
				slides = slideshow.slide_group;
				const linkPattern = '(link_friendlyurl=")([^"]*)';
				if (slides) {
					slides.forEach((slide) => {
						if (_has(slide, 'slide_caption_text["#cdata-section"]')) {
							// eslint-disable-next-line no-param-reassign
							slide.slide_caption_text['#cdata-section'] = slide.slide_caption_text['#cdata-section'].replace(new RegExp(linkPattern, 'gi'), 'href="$2');
						}
					});
				}
			}

			return {
				slideshow,
				slides,
			};
		},

		getModuleByChronicId() {
			const module = this.store.cms.getModules('articleModule') || this.store.cms.getModules(this.chronicId);
			return module;
		},

		getFriendlyUrls() {
			return this.store.cms.friendlyURLData;
		},

		getFriendlyUrl() {
			const friendlyUrls = this.store.cms.friendlyURLData;
			let furl = '';

			// find appropriate site and return prefix and path
			if (friendlyUrls
				&& friendlyUrls.target
				&& friendlyUrls.target.siteid
				&& friendlyUrls.target.friendlyurl
				&& friendlyUrls.target.siteid === '3') {
				// set the protocol
				if (friendlyUrls.target.isHttps && friendlyUrls.target.isHttps.toLowerCase() !== 'true') {
					furl = 'http';
				} else {
					furl = 'https';
				}

				// set the subdomain
				if (friendlyUrls.target.prefix) {
					furl = furl.concat('://', friendlyUrls.target.prefix.toLowerCase());
				} else {
					furl = furl.concat('://', 'www');
				}

				/*
				 * set the TLD and path
				 * @TODO: set the lifecycle and environment
				 */
				return furl.concat('.webmd.com', friendlyUrls.target.friendlyurl.toLowerCase());
			}

			return furl;
		},

		getNextAsset() {
			return this.store.flow.getNextAssetInfo(this.metadataModule.i_chronicle_id);
		},

		getNextAssetSource() {
			const nextAssetSrc = this.store.flow.getNextAssetSource;
			return nextAssetSrc || '';
		},

		getModuleData() {
			const self = this;
			return self.getModuleByChronicId;
		},

		totalSlides() {
			return this.isVertical() ? this.slides.length : this.slides.length + 1;
		},

		runwayAdStyle() {
			if (!this.instreamAds.runwayAd) {
				return {};
			}

			if (this.options.vssSettings.stickyBanner) {
				return {
					height: `calc(${this.instreamAds.runwayAd} + 7rem)`,
				};
			}

			return {
				height: this.instreamAds.runwayAd,
			};
		},

		isInfinite() {
			return this.store.flow.isInfinite;
		},

		fedStyle() {
			if (this.fedConfig && this.fedConfig.styleguide) {
				return {
					'--fed-theme-color': this.fedConfig.styleguide.pe_1,
					'--fed-text-color': this.fedConfig.styleguide.he_1,
				};
			}
			return '';
		},
		isOncology() {
			return this.store.pagedata.isOncology;
		},
	},

	created() {
		this.store = useStore(this.$pinia);
		this.options = merge(this.defaults, this.settings);
		this.moduleByChronicId = this.getModuleByChronicId;

		// Set slideshow data
		this.moduleSettings = this.getModuleData.module_settings;
		const checkTextSS = this.moduleSettings.metadata_section.wbmd_publ.wbmd_publ_name;
		const textOnlySSOptions = ['WebMD Health Tools - Text-Only Slideshow', 'WebMD Health Tools - AI Text-Only Slideshow'];
		this.textOnlySS = textOnlySSOptions.includes(checkTextSS);
		this.metadata = this.getModuleData.module_settings.metadata_section;
		this.moduleData = this.getModuleData.module_data;
		this.slideshow = this.getSlideshow.slideshow;
		this.slides = this.getSlideshow.slides;
		this.loadFirstSlideAd(this.slides);
		this.friendlyUrls = this.getFriendlyUrls;
		this.metadataModule = this.getMetaData();
		this.iaSource = this.getNextAssetSource;
		this.image_server_url = this.store.pagedata.omniture.image_server_url;
		this.ecdQuery = this.$route?.query?.ecd || '';

		if (this.options.vssSettings.seamless) {
			this.nextArticle = this.getNextAsset;
		}
		// eslint-disable-next-line max-len
		this.slideshowType = this.getModuleData.module_data.content_section.cons_slideshow.slide_type_master;

		if ((this.uaType !== 'mobile' && this.options.mode === 'vertical') || (this.isMobile && this.isFlowingFromNews)) {
			this.getNextSlideshow();
		}



		if (this.options.mode === 'vertical') {
			this.store.cms.updateRootClasses(['vertical-ss']);
		}

		this.store.cms.updateRootClasses(['class-bg-ghost']);
	},

	mounted() {
		const self = this;
        // disable the ads call for initial load
		window.webmd.ads.disableInitialLoad();
		// set useragent
		this.uaType = ua.type || 'desktop';
		this.clientWidth = document.body.clientWidth;
		this.isMobile = window.matchMedia("(max-width: 466px)").matches;
		
		//new designs for tablet
		const isInTabletRange = this.clientWidth > 767 && this.clientWidth < 1025;
		this.isNewTabSpec = isInTabletRange && !this.ecdQuery.includes('conmkt');
		if (this.isNewTabSpec) {
			window.ads_ignore = {
				...window.ads_ignore,
				121: true
			};
		}

		if (isInTabletRange && this.ecdQuery.includes('conmkt')) {
			document.documentElement.classList.add('conmkt');
		}
		
		if (this.ecdQuery.includes('conmkt')) {
			this.stickBannerAdOnSS();
		} 

		if (window.matchMedia('(min-width: 768px) and (max-width: 1100px)').matches && this.ecdQuery.includes('conmkttjg')) {
			this.hasconmkttjg = true;
			this.stickBannerAdOnSS();
			this.initAdContainer();
		}

		if (this.isMobile && this.ecdQuery.includes('conmktmjg') && !window.infiniteList) {
			this.removeAndAppendAd('#slide-1');
		} else if(this.textOnlySS) {
			this.removeAndAppendAd('#slide-1 .content-section', this.textOnlySS);
		}
		

		/*
		 * CHECKS THE STATUS OF JS IN BROWSER & IN CASE JS IS DISABLED,
		 * THIS CODE WON'T EXECUTE & LAYOUT WILL REMAIN VERTICAL
		 */

		if (!(document.querySelector('html').matches('no-js'))
			&& this.settings.mode !== 'vertical') {
			this.defaults.mode = 'normal';
		}

		this.instreamAds = merge(this.instreamAds, this.options.vssSettings.instreamAds[this.uaType]);

		/*
		 * Observer for the Interarticle container on Desktop Vertical Infinite slideshows
		 */
		if (this.isInfinite && window.matchMedia("(min-width: 768px)").matches) {
			this.intArtContainerObserver();
		}

		// eslint-disable-next-line no-undef
		this.ads = window.webmd.ads;
		this.adsConsumer = window.webmd.adsConsumer;

		// set mode based on predefined criteria
		this.options.mode = this.isVertical() ? 'vertical' : 'normal';

		// if slideshowOptions are in the window, merge them
		if (window.slideshowOptions) {
			this.options = Object.assign(this.options, window.slideshowOptions);
		}

		// Set Ads fr target
		this.ads.setPageTarget('fr', '1');

		this.setPrdVrsn();

		// Create articleObserver and slideshowList for infinite article
		const contentType = this.nextArticle?.contentType;
		if (contentType && contentType.toLowerCase() !== 'slideshow' && this.uaType !== 'mobile' && !this.isNewTabSpec) {
			this.displayNextArtNav = true;
		} else {
			this.createArticleObserver();
		}

		window.infiniteList = window.infiniteList || {};

		// eslint-disable-next-line max-len
		window.infiniteList[this.metadata.i_chronicle_id] = JSON.parse(JSON.stringify(this.store.pagedata));

		if (this.isInfinite && Object.keys(window.infiniteList).length === 1) {
			document.addEventListener('onAdobeOmniBeforePv', () => {
				const omniVal = `inf-${self.infArticleNumber}-${self.iaSource}`;
				if (window && window.adobeDataLayer) {
					window.adobeDataLayer.push({ page: { ia: omniVal } });
				} else {
					window.s_md.contextData['wb.ia'] = omniVal;
				}
			}, { once: true });
		}

		if (this.textOnlySS && (this.clientWidth > 768 && this.clientWidth < 1025) && this.artNum === 1 && !this.ecdQuery.includes('conmkt')) {
			this.loadAd('infinite-ad-1-2', 141, [[728, 90], [728, 92]]);
		}
		if (window.infiniteList && Object.keys(window.infiniteList).length === 1) {
			this.checkIfAdIsAvailable();
		}
	},

	updated() {
		if (this.options.mode === 'vertical' && !this.initialized) {
			this.initVerticalAds();
			this.initObserver();
			this.removeInterstitials();
			this.initialized = true;
		}
	},

	methods: {
		initAdContainer() {
			const footerAdId = 'footer-ad-pos-141';
			this.loadAd(footerAdId, 141, [[728, 90], [728, 92]]);
		},

		removeAndAppendAd (locator, textOnlySS) {
			const blockToRemove = document.querySelector('#infinite-ad-1-1');
			const parent = blockToRemove.parentNode;
			parent.removeChild(blockToRemove);
			const insertionPoint = document.querySelector(locator);
			if(textOnlySS) {
				insertionPoint.parentNode.appendChild(blockToRemove);
			} else {
				insertionPoint.insertBefore(blockToRemove, insertionPoint.firstChild);
				document.querySelector('.vss-container').classList.add('jungrp');
			}			
		},

		nextSsbtmMod(obj) {
			let frameUrl = '';
			if (obj && obj.friendlyUrl) {
				frameUrl = obj.friendlyUrl;
			} else if (obj && obj.link) {
				frameUrl = `https://${window.location.host.toLowerCase()}${obj.link}`;
			}
			else if (!obj.friendlyUrl && !obj.link && (this.isFlowingFromNews && this.isMobile)){
				frameUrl = this.nextAsset.link;
			}
			return frameUrl;
		},

		triggerFooterModal() {
			const event = new Event('webmd.footer.overlay.open');
			document.dispatchEvent(event);
		},

		loadFirstSlideAd(slides) {
			if (!this.isInitialLoad) {
				const firstCapText = slides[0].slide_caption_text['#cdata-section'];
				if (firstCapText.indexOf('infinite-ad-1-1') === -1) {
					this.slides[0].slide_caption_text['#cdata-section'] = firstCapText.concat('<div id="infinite-ad-1-1" class="ad instreamAd"></div>');
				}
			}
		},

		createRelatedLink(el) {
			const articleLength = this.infArticleNumber;
			const slideNum = el.dataset.slide;
			if (el) {
				const topPicksHTML = `${`<div id="top-picks-mod-${articleLength}-${slideNum}" class="top-picks">`
					+ `<div class="top-pick-container${articleLength}-${slideNum}" style="display: flex;">`
					+ ''}`
					+ '<ul>'
					+ '<li class="entry_fmt">'
					+ '</li>'
					+ '</ul>'
					+ '</div>'
					+ '</div>';
				const adLoc = `infinite-ad-${articleLength}-${el.dataset.slide}`;
				const target = document.getElementById(adLoc);
				target.insertAdjacentHTML('beforebegin', topPicksHTML);
			}
		},

		loadRelatedLink(articleNum, slideNum) {
			const topPicksElement = `#top-picks-mod-${articleNum}-${slideNum} .entry_fmt`;
			const topPicksModule = document.querySelector(topPicksElement);
			if (topPicksModule) {
				const relatedModProps = {
					relMmodule: 'rlt-inwell',
					relMlink: Math.floor(slideNum / 5),
				};
				createApp(instreamRelatedModule, relatedModProps)
					.use(this.$pinia)
					.use(metric)
					.mount(topPicksElement);
			}
		},
		init(slider) {
			this.slider = slider;
			this.getNextSlideshow();
		},
		getMetaData() {
			const module = this.moduleByChronicId;
			const metadata = module && _has(module, 'module_settings.metadata_section') ? module.module_settings.metadata_section : {};
			return metadata;
		},

		addHeightToAdContainers(direction) {
			[...document.querySelectorAll('.slide .instreamAd')].forEach((el) => {
				const adHeight = `${el.offsetHeight}px`;
				if (el && el.children.length > 0 && direction === 'down') {
					// eslint-disable-next-line no-param-reassign
					el.style.minHeight = adHeight;
				} else if (direction === 'up') {
					// eslint-disable-next-line no-param-reassign
					el.style.minHeight = '287px';
				}
			});
		},

		/**
		 * getNextArticleData
		 * Set the next article ID, and dispatch event from the store to get the next article data
		 */
		getNextArticleData(nextAsset, cb) {
			const self = this;
			const newRoute = {
				params: {
					articleid: nextAsset.assetId,
					capid: nextAsset.capId,
					channelid: nextAsset.channelId,
				},
			};

			this.store.cms.getPageAndMetaData({ route: newRoute })
				.then(() => {
					self.store.flow.getFlowInfoForAsset({ route: newRoute })
						.then(() => {
							self.store.flow.setMetadata();
							cb();
						});
				});
		},

		/**
		 * loadNextArticle
		 * Create event for launch rule (infinite-page-loaded)
		 * Extend medref component to create new component with new store's data
		 * Inject new article and inter-article-container after current article
		 * Dispatch event for listeners
		 */
		loadNextArticle(nextArticle) {
			const self = this;
			if (nextArticle) {
				const articleNum = this.infArticleNumber;
				const pageStartedEvent = new CustomEvent('infinite-page-started', { detail: { art: nextArticle.assetId } });
				const iaCont = document.createElement('div');
				const nextArticleEl = document.createElement('div');
				iaCont.className = 'inter-article-container';
				iaCont.id = `iac-${nextArticle.assetId}`;
				self.$el.insertAdjacentElement('afterend', iaCont);
				iaCont.insertAdjacentElement('afterend', nextArticleEl);

				document.dispatchEvent(pageStartedEvent);

				// Load instream NL module
				if (this.isInfinite && !this.isNewTabSpec && !this.displayNextArtNav && ((this.uaType === 'desktop') || (this.uaType === 'tablet'))) {
					const iaNL = document.createElement('div');
					const fullWdSep = document.createElement('div');
					const sp = document.createElement('span');
					fullWdSep.className = 'scroll-down-next';
					sp.innerHTML = 'Scroll Down for the Next Article';
					fullWdSep.appendChild(sp);
					iaNL.className = 'webmd-ia-nl';
					iaNL.id = `inl-${nextArticle.assetId}`;

					// Add scroll down next artilce line
					self.$el.insertAdjacentElement('afterend', fullWdSep);

					const newsletterIA = createApp(webmdNewsletter, {
						nlType: 'in-article',
						location: 'middle',
					})
						.use(self.$pinia)
						.use(metric);
					iaCont.appendChild(iaNL);
					newsletterIA.mount(iaNL);
				}

				// Added the data capture module in between the slideshows on Mobile and tablet
				if (this.isInfinite && ((this.uaType === 'mobile') || this.isNewTabSpec)) {
					const dataCaptCont = document.createElement('div');
					const dataCaptProps = {
						articleNum,
						moduleId: 12,
					};
					const webmdIaDynamicMod = createApp(webmdIAModule, dataCaptProps)
						.use(self.$pinia)
						.use(metric);

					iaCont.appendChild(dataCaptCont);
					webmdIaDynamicMod.mount(dataCaptCont);
				}

				self.getNextArticleData(nextArticle, () => {
					const pageLoadEvent = new CustomEvent('infinite-page-loaded', { detail: { art: nextArticle.assetId } });
					window.initialLoad = true;
					if (nextArticle.contentType && nextArticle.contentType.toLowerCase() === 'slideshow') {
						const artNum = self.infArticleNumber + 1;
						const nextArt = createApp(SlideShowReference, {
							chronicId: '091e9c5e8146bf61',
							fedConfig: nextArticle.fedConfig,
							isInitialLoad: true,
							nextArticleSource: self.iaSource,
							infArticleNumber: artNum,
						})
							.use(self.$pinia)
							.use(metric);

						// Mount the new article, throw global event
						nextArt.mount(nextArticleEl);
					} else if (nextArticle.contentType === 'Article' && (this.isMobile || this.isNewTabSpec)) {
						const artNum = self.infArticleNumber + 1;
						const isBlogArt = Boolean(nextArticle && nextArticle.busRef === 'Blog Post');

						if (window && window.adobeDataLayer) {
							window.adobeDataLayer.push({ page: { prdvrsn: '' } });
						}
						
						const nextArt = createApp(MedicalReference, {
							chronicId: self.chronicId,
							fedConfig: nextArticle.fedConfig,
							nextArticleSource: self.iaSource,
							infArticleNumber: artNum,
							isBlogArticle: isBlogArt,
						})
							.use(self.$pinia)
							.use(metric);

						// Mount the new article, throw global event
						nextArt.mount(nextArticleEl);
					} else {
						this.displayNextArtNav = true;
					}

					// Mount the new article, throw global event

					document.dispatchEvent(pageLoadEvent);

					// Create Ad containers for 101 ads
					if (self.uaType !== 'mobile' && !this.isNewTabSpec && !this.displayNextArtNav && !(this.ecdQuery.includes('conmkt'))) {
						const pos101adCont = self.infArticleNumber + 1;
						const wrapperOneoOne = `<div class="ad-wrapper ad-container-101 instream-101"><div id="ad-101-${pos101adCont}" class="module ad ad-101"></div>`;
						const iacnId = `iac-${nextArticle.assetId}`;
						const iacContainer = document.getElementById(iacnId);
						iacContainer.insertAdjacentHTML('afterend', wrapperOneoOne);
					}
				});
			}
		},

		loadAd(adId, posValue, adSizes) {
			if (window && window.webmd && window.webmd.adsConsumer && !window.webmd.ads.ads[adId]) {
				window.webmd.adsConsumer.defineAd({
					id: adId,
					class: 'ad-wrapper',
					pos: posValue,
					sizes: adSizes,
				});
			}
		},


		/**
		 * getArticleProps
		 * Get and return specific properties about the newly loaded article
		 * Title and path for history
		 * Select metrics properties
		 */
		getArticleProps() {
			const { meta, omniture: omni } = this.store.pagedata;
			return {
				chronicId: this.metadata.i_chronicle_id,
				title: meta.page_title,
				path: omni.s_furl,
				ogTags: meta.og_tags,
				pageName: omni.s_pagename ? omni.s_pagename : '',
				metrics: {
					pageURL: `https://${omni.s_pagename}`,
					prop6: omni.s_business_reference,
					prop7: this.metadata.i_chronicle_id,
					prop16: 'VISB1T2',
					prop29: omni.s_sponsor_brand,
					prop30: omni.s_package_type !== '' ? `${omni.s_package_type} - sp` : '',
					prop36: omni.s_topic_dir === 'true' ? 'tpdr-true' : '',
				},
			};
		},

		/**
		 * createArticleObserver
		 * Create intersection observer at the bottom of each article to change the
		 * url and history store as user scrolls up and down through articles
		 */
		createArticleObserver() {
			const self = this;
			const observer = new IntersectionObserver((entries) => {
				const entry = entries[0];

				if (entry.isIntersecting) {
					if (entry.intersectionRect.top === 0) {
						self.updateArticleHandler(entry.target, 'up');
					} else {
						self.updateArticleHandler(entry.target, 'down');
					}
				}
			});

			observer.observe(this.$el);
		},

		/**
		 * handleIntersection
		 * Observer handler
		 */
		updateArticleHandler(target, direction) {
			const self = this;
			const article = window.infiniteList[target.dataset.artid];
			const articleEl = target;
			const allArts = document.querySelectorAll('article, .webmd-tool-slideshow');

			if (articleEl) {
				[...allArts].forEach((art) => art.classList.remove('current'));
				articleEl.classList.add('current');
			}

			if ((direction === 'down' || direction === 'up') && Object.keys(window.infiniteList).length > 1) {
				if (direction === 'down') {
					self.$vwmdTrack({
						moduleName: `pg-n-swipe_inf-${this.nextArticleSource}`,
					});
					document.addEventListener('onAdobeOmniBeforePv', () => {
						const omniVal = `inf-${self.infArticleNumber}-${self.iaSource}`;
						if (window && window.adobeDataLayer) {
							window.adobeDataLayer.push({ page: { ia: omniVal } });
						} else {
							window.s_md.contextData['wb.ia'] = omniVal;
						}
					}, { once: true });
				} else {
					self.$vwmdTrack({
						moduleName: 'pg-n-swipe',
					});
				}
				this.updateUrl(article);
				this.updatePageData(article);
				this.setPrdVrsn();
				if (this.uaType === 'mobile' || this.uaType === 'tablet') {
					this.addHeightToAdContainers(direction);
				}
			}
		},

		/**
		 * updateUrl
		 * Update history (and url in address bar)
		 */
		updateUrl(article) {
			try {
				window.document.title = article.meta.page_title;
				if (article.omniture.s_furl && article.omniture.s_furl !== '') {
					window.history.replaceState({}, '', article.omniture.s_furl);
				}
			} catch (err) {
				// couldn't replace store
			}
		},

		/**
		 * updateMetricsProps
		 * When new article is loaded, fire PV for page1 with updated metrics props
		 */
		updatePageData(articleProps) {
			const self = this;

			self.store.cms.updatePagedata(articleProps);

			try {
				// eslint-disable-next-line no-global-assign
				window = Object.assign(window, self.store.pagedata.omniture);
			} catch (err) {
				// do nothing
			}

			try {
				self.$vwmdReset(true);
			} catch (err) {
				// do nothing
			}
		},
		getImagePath(slideInfo, mobile, index) {
			const { path } = slideInfo.slide_img;
			const indexVal = index + 1;
			if (mobile) {
				if (indexVal === 1) {
					return `${this.image_server_url + path}?resize=375px:250px&output-quality=75`;
				}
				return `${this.image_server_url + path}?resize=375px:250px&output-quality=100`;
			}
			if (indexVal === 1) {
				return `${this.image_server_url + path}?resize=728px:*&output-quality=75`;
			}
			return `${this.image_server_url + path}?resize=728px:*&output-quality=100`;
		},

		createAdContainer(elWrapper, elementToPlace, mountable, artLen) {
			if (!(elWrapper.dataset.slide === '1' && artLen === 1)) {
				let indexVal;
				// eslint-disable-next-line no-plusplus
				for (let i = 0; i < elWrapper.length; i++) {
					if (elWrapper.className.includes('slide')) {
						indexVal = i;
						break;
					}
				}
				elWrapper.append(elementToPlace);
			}
			if (mountable) {
				mountable.mount(elementToPlace);
			}
		},

		getNextSlideshow() {
			let responseData = false;

			axios.get(
				`https://www.webmd.com/kapi/getnextasset?id=${this.metadata.i_chronicle_id}`,
			)
				.then((response) => {
					responseData = response.data;
					if (responseData !== false) {
						this.nextAsset = {
							title: responseData.title,
							link: responseData.friendlyUrl,
							image: this.image_server_url + responseData.thumbnail.image_path + (this.uaType === 'mobile' ? '?resize=375px:250px&output-quality=75' : ''),
							imageAlt: responseData.thumbnail.alt_tag,
						};
					} else if (responseData === false) {
						this.nextAsset = {
							link: this.getDefaultssPath(),
							image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAe0AAAFPCAMAAABXvmYsAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTBEMkVGQTgzMjdGMTFFNkJENjQ5MERENjNEQkEzQTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTBEMkVGQTkzMjdGMTFFNkJENjQ5MERENjNEQkEzQTMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBMEQyRUZBNjMyN0YxMUU2QkQ2NDkwREQ2M0RCQTNBMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBMEQyRUZBNzMyN0YxMUU2QkQ2NDkwREQ2M0RCQTNBMyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvbRlE4AAAAGUExURf///wAAAFXC034AAAC6SURBVHja7MExAQAAAMKg9U9tCy+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPiaAAMAhpAAAXDtuHkAAAAASUVORK5CYII=',
						};
					}
				})
				.catch(() => {
					// do nothing
				});
		},
		getDefaultssPath() {
			let nextSSPath;
			const path = window.location.href;
			if (path && path.indexOf('ss/') !== -1) {
				const pathname = path.split('ss/');
				nextSSPath = `${pathname[0]}ss/default.htm`;
			}
			return nextSSPath;
		},

		isVertical() {
			const self = this;
			const excludedPackages = ['editorial destination', 'webmd tv', 'premium video'];
			const excludedPubs = ['WebMD Health Tools - Horizontal Slideshow'];

			if (self.settings.mode) {
				return self.options.mode !== 'normal';
			}

			if (self.friendlyUrls && _has(self.friendlyUrls, 'target.centers.Package.name')) {
				if (excludedPackages.includes(self.friendlyUrls.target.centers.Package.name)) {
					return false;
				}
			}

			if (excludedPubs.includes(self.moduleSettings.metadata_section.wbmd_publ.wbmd_publ_name)) {
				return false;
			}

			if (typeof window !== 'undefined' && window.location.search.includes('vss')) {
				return true;
			}

			return true;
		},

		// eslint-disable-next-line consistent-return
		initVerticalAds() {
			const self = this;

			if ((self.infinite && this.uaType === 'mobile') || this.options.vssSettings.stickyRRad === false) {
				return false;
			}
			
			if (this.uaType !== 'mobile') {
				window.googletag.cmd.push(setTimeout(() => { self.stickRRad(); }, 500));
			}
		},

		stickRRad() {
			const ceilingElement = (this.options.mode === 'vertical') ? '.ad-container-101' : '.global-main';
			const floorElement = this.isInfinite ? '#ContentPane34' : '.sources-and-share-bar';
			try {
				this.sticky({
					element: '.ad-121',
					startOnTouch: true,
					name: 'RRStickyAd',
					ceiling: ceilingElement,
					floor: floorElement,
					className: 'ss-ad-rr-fixed',
				});
			} catch (e) {
				// do nothing
			}
		},

		intArtContainerObserver() {
			const self = this;
			const intartCont = '.inter-article-container';
			const options = {
				rootMargin: '0px 0px 0px 0px',
			};
			const observerNew = new IntersectionObserver(
				self.observeNewIntersection,
				options,
			);

			[...document.querySelectorAll(intartCont)].forEach((el) => {
				observerNew.observe(el);
			});
		},

		// Unstick right rail 121 ad when the interarticle conatiner is in view
		observeNewIntersection(entries) {
			const self = this;
			const rrAd = 'ad-pos-121-1';
			entries.forEach((entry) => {
				self.currentY = window && window.pageYOffset;
				if (entry.isIntersecting) {
					document.getElementById(rrAd).style.position = 'relative';
				} else {
					document.getElementById(rrAd).style.position = 'fixed';
				}
				self.previousY = self.currentY;
			});
		},

		initObserver() {
			const self = this;
			const observer = new IntersectionObserver(self.observeIntersection);
			const selector = '.slide';
			[...self.$el.querySelectorAll(selector)].forEach((el) => {
				observer.observe(el);
				if ((self.uaType === 'mobile' || this.isNewTabSpec) && self.instreamRecModule) {
					if ((parseInt(el.dataset.slide, 10) === 5
						|| (parseInt(el.dataset.slide, 10) === (this.totalSlides - 1))) && !this.$route?.query?.ecd) {
						this.createRecTopPicks(el);
					} else {
						this.createPropsAndAd(el);
					}
				} else {
					this.createPropsAndAd(el);
				}
				if ((parseInt(el.dataset.slide, 10) % 5 === 0) && self.uaType !== 'mobile' && !this.isNewTabSpec) {
					this.createRelatedLink(el);
				}
			});
		},
		createAd(element) {
			const self = this;
			const adContainer = element.querySelector('.instreamAd');

			this.ads.defineAd({
				id: adContainer.id,
				pos: self.instreamAds.pos,
				sizes: self.instreamAds.sizes,
			});
		},
		createPropsAndAd(el) {
			const adEl = document.createElement('div');
			const centerIds = ['1004', '1005', '1011', '1115', '1018', '1026', '1081'];
			const isSponsored = this?.store?.pagedata?.omniture?.s_sponsor_program !== '';
			const pageCenterId = window.__INITIAL_STATE__?.pagedata?.omniture?.center_id;			
			adEl.id = `infinite-ad-${this.infArticleNumber}-${el.dataset.slide}`;
			adEl.className = 'ad instreamAd';
			const adTargets = this.store.pagedata.ad.targets;
			adTargets.pg = `${el.dataset.slide}`;
			adTargets.ll = 1;
			const adId = `infinite-ad-${this.infArticleNumber}-${el.dataset.slide}`;
			let posValue;
			let posSizes;
			const clientWidth = document.body.clientWidth;
			const isPartOfTest =
				centerIds.includes(pageCenterId) &&
				clientWidth >= this.iaAds.desktop.clntWidth &&
				!isSponsored &&
				!this.ecdQuery.includes('conmkt');
			const topValue = isPartOfTest ? 50 : (this.uaType === 'mobile') ? 400 : 0;


			if (clientWidth >= this.iaAds.desktop.clntWidth) {
				posValue = this.iaAds.desktop.pos;
				posSizes = this.iaAds.desktop.sizes;
			} else if (clientWidth < this.iaAds.desktop.clntWidth
				&& clientWidth > this.iaAds.tablet.clntWidth) {
				posValue = this.iaAds.tablet.pos;
				posSizes = this.iaAds.tablet.sizes;
				if(this.isNewTabSpec) {
					posValue = '141',
					posSizes = [[728, 90], [728, 92]]
				}
			} else if (clientWidth <= this.iaAds.tablet.clntWidth) {
				posValue = this.iaAds.mobile.pos;
				posSizes = this.iaAds.mobile.sizes;
			}
			const data = {
				first: el.dataset.slide === '1',
				last: parseInt(el.dataset.slide, 10) === this.totalSlides,
				margin: {
					top: el.dataset.slide === '1' ? 0 : topValue,
					bottom: 0,
				},
				slideNum: el.dataset.slide,
				contentType: 'slideshow',
				partOfTest: isPartOfTest,
				chronId: this.metadataModule.i_chronicle_id || '',
				ad: {
					pos: posValue,
					sizes: posSizes,
					id: adId,
					targets: { ...adTargets },
				},
			};
			if (this.uaType === 'mobile' && el.dataset.slide === '1' && this.infArticleNumber === 1) {
				data.margin.top = 1000;
			}

			if (this.uaType === 'mobile' && (el.dataset.slide === '1' || el.dataset.slide === '2' || el.dataset.slide === '3') && this.infArticleNumber === 1 && this.ecdQuery.includes('conmktmfb')) {
				data.margin.top = 5000;
			}

			if ((this.uaType === 'desktop' || this.uaType === 'tablet') && el.dataset.slide === '1') {
				if(isPartOfTest) {
					data.margin.top = 1000;
				} else {
					data.margin.top = 550;
				}				
			}



			const instreamAd = createApp(iaAd, data)
				.use(this.$pinia);

			this.createAdContainer(el, adEl, instreamAd, this.infArticleNumber);
		},

		createRecTopPicks(el) {
			// eslint-disable-next-line no-bitwise
			const recTpMod = `rec-top-pk-mod-${(((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)}`;
			const rectopEle = document.createElement('div');
			const recProps = {
				margin: {
					top: 400,
					bottom: 100,
				},
			};

			if (this.uaType === 'mobile' && this.infArticleNumber === 1) {
				recProps.margin.top = 800;
			}

			rectopEle.setAttribute('id', recTpMod);
			rectopEle.setAttribute('class', 'instream-feature-module-container');
			if (el) {
				el.insertAdjacentElement('afterend', rectopEle);
				createApp(instreamFeaturedModule, recProps)
					.use(this.$pinia)
					.use(metric)
					.mount(rectopEle);
			}
		},

		observeIntersection(entries) {
			const self = this;
			entries.forEach((entry) => {
				this.currentY = window && window.pageYOffset;
				if (entry.isIntersecting) {
					if (this.currentY >= this.previousY) {
						self.handleIntersection(entry.target, 'down');
					} else if (this.currentY < this.previousY) {
						if (entry.intersectionRect.top === 0) {
							self.handleIntersection(entry.target, 'up');
						}
					}
				}
				this.previousY = this.currentY;
			});
		},

		isInViewport(el) {
			const rect = el.getBoundingClientRect();

			// DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
			const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
			const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

			// http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
			const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
			const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

			return (vertInView && horInView);
		},

		slideMetrics(metricParam, slideNum, refresh, linkTextValue) {
			const self = this;
			const ssContainers = document.querySelectorAll('.webmd-tool-slideshow');
			// eslint-disable-next-line max-len
			const topOffset = ssContainers?.length ? ssContainers[ssContainers.length - 1].offsetTop : 0;
			let count = '';
			if (!this.isVertical()) {
				count = ((this.currentSlide === this.totalSlides) && this.uaType !== 'mobile') ? 'transition-end' : slideNum;
			} else {
				count = (slideNum === this.totalSlides) ? `${slideNum}-end` : slideNum;
			}
			this.$vwmddpv({
				moduleName: `ss-${metricParam}`,
				iCount: count,
				refresh: refresh || false,
			},
			this.isInfinite ? {
				metrics: {
					'wb.lnktxt': linkTextValue,
					'wb.ia': `inf-${self.infArticleNumber}-${self.iaSource}`,
				}
			} : {
				metrics: {
					'wb.lnktxt': linkTextValue,
				}
			});


			if (!this.isVertical() && (ssContainers && ssContainers.length) === 1) {
				window.scrollTo({ top: -(topOffset + 65), behavior: 'smooth' });
			}
		},

		handleIntersection(el, dir) {
			const self = this;
			const slideCount = parseInt(el.id.split('-')[1], 10);
			const index = slideCount - 1;
			const pvTimeout = (dir === 'down') ? 0 : this.options.vssSettings.pvTimeout;
			let metricParam;

			const slideNumber = parseInt(el.dataset.slide, 10);

			if (slideNumber % 5 === 0 && !self.isMobile) {
				this.loadRelatedLink(this.infArticleNumber, slideNumber);
			}

			// PV counting
			clearTimeout(this.pvTimer[`slide${index}`]);
			this.pvTimer[`slide${index}`] = setTimeout(() => {
				let isLastSlide;
				let isFirstSlide;

				if (this.isInViewport(el)) {
					isLastSlide = slideCount === this.totalSlides;
					isFirstSlide = slideCount === 1;
					if (isLastSlide && !this.lastSlideReached) {
						metricParam = 'next_end';
						this.lastSlideReached = true;
						if (!this.turnOffInfinite && !this.displayNextArtNav) {
							
							if (!this.isFlowingFromNews) {
								self.loadNextArticle(self.nextArticle);
							}

						}
					} else {
						metricParam = (dir === 'up' ? 'prev' : 'next');
					}
					if ((isFirstSlide && dir === 'up') || !isFirstSlide) {
						this.slideMetrics(metricParam, slideCount);
					}
				}
			}, pvTimeout);
		},

		removeInterstitials() {
			this.slides = this.slides.filter((slide) => !slide.slide_type_child || !slide.slide_type_child.includes('Interstitial Ad'));
		},

		stickBannerAdOnSS() {
			const topAdSS = document.querySelector('.ad-container-101');
			const topStickyCreatedSS = topAdSS ? topAdSS.classList.contains('is-fixed-banner-ad') : null;

			if (topAdSS && !topStickyCreatedSS) {
				this.sticky({
					element: '.ad-container-101',
					name: 'bannerAdStickySS',
					css: {
						marginTop: '0px',
						top: '0px',
						width: '100%',
						zIndex: '99999',
						background: '#ffffff',
					},
					ceiling: true,
					startOnTouch: false,
					className: 'is-fixed-banner-ad',
				});
			}
		},
		checkIfAdIsAvailable () {
			const self = this;
			let val = 'infinite-ad-1-1' in window.webmd.ads.ads;
			if (val) {
				window.webmd.ads.refresh();
			} else {
				// Elements are not present, wait for 100ms and try again
				if (self.adCheckCount < 500) {
					setTimeout(() => {
						self.adCheckCount = self.adCheckCount + 1;
						self.checkIfAdIsAvailable();
					}, 300);
				}
			}
		},

		setPrdVrsn() {
			// Set product version
			const pageBusRef = this?.store?.pagedata?.omniture?.s_business_reference.toLowerCase() || '';
			if (window && window.adobeDataLayer) {
				if (pageBusRef === 'tool - slide show') {					
					if (this.textOnlySS) {
						window.adobeDataLayer.push({ page: { prdvrsn: 'ss-list' } });
					} else {
						window.adobeDataLayer.push({ page: { prdvrsn: 'ss-image' } });
					}					
				} else {
					window.adobeDataLayer.push({ page: { prdvrsn: '' } });
				}
			}
		},
	},
};
</script>

<style lang="scss">
@import './scss/print-styles.scss';
@import './scss/vertical.scss';
$base-font-family-sans: "Source Sans Pro", Arial, sans-serif;
$base-font-family-condensed: "Roboto Condensed",Verdana,sans-serif;
$header-black: #333132;
$medium-grey: #dbdbdb;
$dark-grey: #767674;
$text-grey: #444;
$nojs-link-grey: #979797;
$bg-disabled: #e8e6e6;
$link-blue: #3557ff;
$white: #fff;
$img-bg: #efedee;
$light-blue: #f1fafd;
$imperial: #00157c;
$redirect-mask: rgba(0,0,0,0.6);
$lavender: #CCCCE7;
$carbon: #1B1B1B;
$ultramarine: #3557FF;
$ghost: #F8F8F8;

$breakpoint-mobile: 47.938rem; // 767.008px
$mobile: 20rem; // 320px
$tablet: 48rem; // 768px
$tablet-controls: 48.063rem; // 769.008px
$small-desktop: 64rem; // 1024px
$large-desktop: 77.5rem; // 1240px

@keyframes fadeIn {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

html.vertical-ss {
	main#global-main {
		@media only screen and (max-width: $breakpoint-mobile){
			padding: 0;
		}
	}
	.ss-ad-rr-fixed {
		left: auto !important;
		top: 9rem !important;
		width: 19.5rem
	}

	article.medref {
		padding: 0 0.625rem;
		.instreamAd {
			width: 100vw !important;
			@media only screen and (min-width: $tablet) and (max-width: $small-desktop) {
				width: 100% !important;
			}
		}
	}

	.subnav-container {
		left: 0;
		margin-left: 0;
		width: 100%;

		@media (min-width: $small-desktop) {
			width: calc(100% + #{px2rem(352)});
		}
	}

	.webmd-breadcrumb.breadcrumb {
        margin: 0 1.25rem;
    }

	.webmd-tool-slideshow {
		margin: 0 px2rem(20);
		@media (min-width: $small-desktop) {
			margin: auto;
		}
	}

}

@import 'scss/ads';
.ad-container {
	background: #f7f7f7;
	bottom: 0;
	height: auto;
	min-height: 90px !important;
	margin: 0 calc(-50vw + 50% + -40px);
	padding: 16px 0;
	position: fixed;
	width: 100vw;
	z-index: 9999;

	.footer-ad-141 {
		height: 90px;
		width: 728px;
	}
}
.ia-art {
	.webmd-tool-slideshow + div,
	.webmd-tool-slideshow + aside {
		margin-top: 4.0625rem;

		&:not(.instream-drug-mono) {
			@media only screen and (max-width: $breakpoint-mobile) {
				border-top: 1px solid $bg-disabled;
				margin-top: 3.5rem;
				padding-top: 1.5rem;
			}
		}
	}
}

.webmd-tool-slideshow {
	@import 'scss/header';
}

.webmd-tool-slideshow {
	.text-ss-border {
		margin-bottom: 30px;
		@media screen and (max-width: $breakpoint-mobile) {
			border: 1px solid #dbdbdb;
			margin: 15px 10px 30px 10px;
		}
	}
}
@media screen and (max-width: $breakpoint-mobile) {
	.inter-article-container {
		.ia-data-capture-module {
			margin-top: 0;
		}
	}

}
@media (min-width: $tablet) {
	.slide-sharebar {
		text-align:right;
		.module-social-share-container .plugin-socialshare-link:link:last-child {
			margin:0;
		}
	}
}
.webmd-tool-slideshow .policy-link {
	color: $carbon;
	display: block;
	font-size: 0.875rem;
	text-decoration: none;

	@media screen and (max-width: $breakpoint-mobile) {
		display: block;
		margin-top: 0.75rem;
	}

	&:hover {
		color: $ultramarine;
	}
}

@media screen and (max-width: 465px) {
	.webmd-tool-slideshow .module-top-picks.module-instream-toppks {
		padding-top: 1rem !important;
		padding-bottom: 0.6rem !important;
		margin: 2.5rem 0 !important;
	}
}
@media only screen and (max-width: 47.938em) {
	.webmd-tool-slideshow.vertical .slide .ad.instreamAd {
		min-height: 18rem;
		margin: 1.875rem 0 1rem 0;
		padding: 0.75rem 0;
	}
}

.sources-and-share-bar {
	justify-content: space-between;
	margin: 1.25rem 0 0 0;

	.module-social-share-container {
		position: absolute;
		right: 0;
	}
}

.copyright-and-policy {
	display: block;
	margin: 0.75rem 0 1.25rem 0;

	.copyright {
		font-size: 0.875rem;
		line-height: 0.9375rem;
	}
}

.scroll-down-next {
	align-items: center;
	background: transparent;
	color: #767674;
	display: flex;
	font-family: $base-font-family-sans;
	font-size: 1rem;
	font-weight: normal;
	margin-top: 1.5rem;
	padding-top: 1.5rem;
	text-align: center;
	&:before,
	&:after {
		content: '';
		flex: 1;
		border-bottom: .0625rem solid #d3d3d3;
	}

	&:not(:empty)::before {
		margin-right: 1.5rem;
	}

	&:not(:empty)::after {
		margin-left: 1.5rem;
	}

	span {
		color: #444;
		font-family: $base-font-family-sans;
		&:before,
		&:after {
			content: url('https://img.wbmdstatic.com/vim/live/webmd/consumer_assets/site_images/icons/scroll-down.png');
		}

		&:not(:empty)::before {
			margin-right: .75rem;
		}

		&:not(:empty)::after {
			margin-left: .75rem;
		}
	}
}
.webmd-tool-slideshow {
	.top-picks {
		@media (min-width: $tablet) {
			margin-top: 2rem;
			margin-bottom: 0 !important;
		}

		.top-pick-container {
			display: flex;
			flex-direction: row;
			padding: 0 0 px2rem(32);
			width: 100%;

			li {
				margin-bottom: 0;
			}
		}

		ul {
			list-style: none;
			margin: 0;
			padding: 0;
			width: 90%;
		}

		@media (max-width: $breakpoint-mobile) {
			display: none;
			.entry_fmt {
				font-size: px2rem(28);
				margin-right: px2rem(12);
			}
		}

		hr {
			display: none;
		}

		.heading {
			align-items: center;
			color: $imperial;
			display: flex;
			font-size: px2rem(18);
			font-weight: 700;
			letter-spacing: 0.05em;
			margin-right: 0 !important;
			width: auto;

			span {
				border-bottom: none;
				border-image: none;
				border-image-slice: 0;
				color: $imperial !important;
				font-size: 18px;
				font-weight: 700;
				text-transform: uppercase !important;
			}
		}

	}
}

@media only screen and (min-width: $tablet) {
	.instream-101 {
		margin-bottom: 2.75rem;
		min-width: 45.5rem;
		padding-left: 1.25rem;
	}
	html.class-bg-ghost {
		.module.ad.ad-101 {
			background: $ghost !important;
		}
		.module.ad.ad-121, .module.ad.ad-137 {
			background: $ghost !important;
		}
	}
}

.webmd-onc {
	  .module.ad.ad-121 {
        margin-top: 0;
    }
}


@import 'scss/nojs.scss';
</style>
